import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import "./style.sass";
import { InputTypeAndroid } from 'components/Forms/InputType';
import { ClasicSelectTypeNew } from 'components/Forms/Select';
import getShipping from 'services/getShipping';
import { BarraStepper } from 'components/Credito/BarraStepper';
import { useStorage64 } from 'hooks/useStorageBase64'
import { decodeStorage } from 'functions/storageBase64'
import { ocupacion, tipoEmpresa, estadosAbreviacion } from 'constants/variables';
import { ModalError } from 'components/Error/ErrorModal';

export function InformacionEmpleoDesktop(props) {
    const { nextPage, cancelar } = props;

    const [shipping, setShupping] = useState({});
    const infoTrabajoStorage = decodeStorage("infoTrabajoStorage")
    //console.log('infoTrabajoStorage: ', infoTrabajoStorage)
    const [datosEmpleo, setDatosEmpleo] = useState(infoTrabajoStorage);

    const [inputEmpresa, setInputEmpresa] = useState();
    const [inputTelefono, setInputTelefono] = useState();
    const [inputExtencion, setInputExtencion] = useState();
    const [inputAniosEmpresa, setInputAniosEmpresa] = useState();
    const [inputMesesEmpresa, setInputMesesEmpresa] = useState();

    const [inputCalle, setInputCalle] = useState();
    const [inputNumExt, setInputNumExt] = useState();
    const [inputNumInt, setInputNumInt] = useState();
    const [inputCP, setInputCP] = useState(datosEmpleo?.CPEmp);

    const [estado, setEstado] = useState();
    const [municipio, setMunicipio] = useState();
    const [ciudad, setCiudad] = useState();
    const [colonia, setColonia] = useState();

    const [entreCalles, setEntreCalles] = useState();
    const [inputIngresosMensuales, setInputIngresosMensuales] = useState();
    const [inputOtrosIngresos, setInputOtrosIngresos] = useState();
    const [inputFuenteOtros, setInputFuenteOtros] = useState();

    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);
    const [, setInfoTrabajoStorage] = useStorage64('infoTrabajoStorage', '');

    const [errorCode, setErrorCode] = useState()
    const [messageResponse, setMessageResponse] = useState()
    const [sectionActive, setSectionActive] = useState("")
    const [showModalErr, setShowModalErr] = useState(false);

    const { register, handleSubmit, errors, clearErrors } = useForm({
        defaultValues: {
            empresa: datosEmpleo.Empresa,
            tipoEmpresa: datosEmpleo.TipoEmpresa,
            ocupacion: datosEmpleo.Ocupacion,
            telefono: datosEmpleo.TelEmpresa,
            extension: datosEmpleo.Ext,
            mesesEmpresa: datosEmpleo.TiempoEmpMes,
            aniosEmpresa: datosEmpleo.TiempoEmpAnio,
            calle: datosEmpleo?.DireccionEmpleo?.split(',')[0],
            numExt: datosEmpleo?.DireccionEmpleo?.split(',')[1]?.split(' ')[0],
            numInt: datosEmpleo?.DireccionEmpleo?.split(',')[1]?.split(' ')[1],
            cp: datosEmpleo.CPEmp,
            colonia: datosEmpleo.colonia,
            municipio: datosEmpleo.municipio,
            estado: datosEmpleo.estado,
            ciudad: datosEmpleo.ciudad,
            entreCalles: datosEmpleo.entreCalles,
            ingresosMensuales: datosEmpleo.Ingmensual,
            otrosIngresos: datosEmpleo.OtroIngresos,
            fuenteOtros: datosEmpleo.FuenteOtroIngresos,
        }
    });
    // guarda la informacion enviada en el formulario
    const sendFormInformacionEmpleo = data => {
        let resultado = [];
        estadosAbreviacion.map((ele) =>
            ele.completo === String(data.estado).toLowerCase()
                ? resultado.push(ele.inicial)
                : null//resultado.push(data.estado)
        )

        setDatos({
            "Empresa": data.empresa,
            "TipoEmpresa": String(data.tipoEmpresa),
            "Ocupacion": String(data.ocupacion),
            "TelEmpresa": data.telefono,
            "Ext": data.extension,
            "TiempoEmpMes": data.mesesEmpresa,
            "TiempoEmpAnio": data.aniosEmpresa,
            "DireccionEmpleo": data.calle + "," + data.numExt + " " + data.numInt,
            "CPEmp": data.cp,
            "ColoniaEmp": data.colonia,
            "MunicipioEmp": data.municipio,
            "EstadoEmp": resultado[0],//data.estado,
            "CiudadEmp": data.ciudad,
            // "entreCallesEmp": data.entreCalles,
            "Ingmensual": data.ingresosMensuales,
            "OtroIngresos": data.otrosIngresos,
            "FuenteOtroIngresos": data.fuenteOtros
        })

        // console.log("datos empleo---- ", data)
        SetReturnForm(true);
    };

    useEffect(() => {
        if (inputCP) {
            if (inputCP.length === 5) {
                getShipping({ codigoPostal: inputCP })
                    .then(setShupping)
            }
            else if (inputCP.length < 5 || inputCP.length === 0) {
                setEstado('');
                setMunicipio('');
                setCiudad('');
                setColonia([]);
            }
        }
    }, [inputCP])

    useEffect(() => {
        if (shipping) {
            setEstado(shipping.estado);
            setMunicipio(shipping.municipio);
            setCiudad(shipping.ciudad);

            if (shipping?.code === 200) {
                clearErrors('estado');
                clearErrors('ciudad');
                clearErrors('colonia');
                clearErrors('municipio');
            }

            if (shipping.colonias) {
                if (shipping.colonias.length === 0) {
                    setColonia([]);
                }
                else if (shipping.colonias.length >= 1) {
                    setColonia(shipping.colonias);
                }
            }

            if (shipping?.code === 404) {
                setShowModalErr(true);
                setErrorCode(shipping?.code);
                setSectionActive('cp');
                setMessageResponse(shipping?.error);
            }
        }
    }, [shipping])

    // al recibir data del formulario se guarda en variable datos empleo
    useEffect(() => {
        if (returnForm) {
            setDatosEmpleo(datos);
            setInfoTrabajoStorage(datos);
            SetReturnForm(false);
            nextPage(3);
        }
    }, [returnForm])

    const valEmpresa = {
        required: 'Campo obligatorio',
    };
    const valTipoEmpresa = {
        required: 'Campo obligatorio',
    };
    const valOcupacion = {
        required: 'Campo obligatorio',
    };
    const valTelefono = {
        required: 'Campo obligatorio',
        minLength: {
            value: 10,
            message: 'El teléfono debe de tener 10 dígitos'
        },
        maxLength: {
            value: 10,
            message: 'El teléfono debe de tener 10 dígitos'
        },
        pattern: {
            value: /[0-9]{10}/,
            message: 'El formato de teléfono es inválido'
        }
    };
    const valExtension = {
    };
    const valCalle = {
        required: 'Campo obligatorio',
    };
    const valNumExt = {
        required: 'Campo obligatorio',
    };
    const valNumInt = {
    };
    const valCp = {
        required: 'Campo obligatorio',
        minLength: {
            value: 5,
            message: 'Faltan dígitos. Deben ser 5 dígitos'
        },
        maxLength: {
            value: 5,
            message: 'No debe contener más de 5 dígitos'
        },
        pattern: {
            value: /[0-9]{0,99999}/,
            message: 'El formato de CP es inválido'
        }
    };
    const valAniosEmpresa = {
        required: 'Campo obligatorio',
    }
    const valMesesEmpresa = {
        required: 'Campo obligatorio',
        max: {
            value: 11,
            message: 'La cantidad máxima de meses que puede tener este campo son 11'
        }
    }
    const valEstado = {
        required: 'Campo obligatorio',
    };
    const valMunicipio = {
        required: 'Campo obligatorio',
    };
    const valCiudad = {
        required: 'Campo obligatorio',
    };
    const valColonia = {
        required: 'La Colonia es requerida',
        minLength: {
            value: 1,
            message: 'El estado es requerido'
        },
        maxLength: {
            value: 120,
            message: 'La colonia debe tener un máximo de 120 caracteres'
        }
    };
    const valIngresosMensuales = {
        required: 'Campo obligatorio',
    };

    const valFuenteOtros = {
    };
    const valOtrosIngresos = {
    };
    const valEntreCalles = {
    };

    // realiza accion al cerrar modal error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (String(sectionActive) === 'cp') {
            setInputCP();
            document.getElementById("cp").value = "";
        }
    }


    return (
        <>
            <BarraStepper itemActivo={2} />

            <form className="" onSubmit={handleSubmit(sendFormInformacionEmpleo)}>
                <div className="infoEmpleoFrom">
                    <div className="infoPersonalGeneral">
                        <div className="tituloSeccion">
                            <p>Empleo Actual</p>
                        </div>

                        <div className="secEmpleo">
                            <div className="campo">
                                <InputTypeAndroid
                                    type="text"
                                    id="empresa"
                                    name="empresa"
                                    placeholder="Empresa o patrón"
                                    className="desktopInput"
                                    errorMessage={errors.empresa && errors.empresa.message}
                                    refs={register(valEmpresa)}
                                    maxLength={20}
                                    setNumero={setInputEmpresa}
                                    // value={inputEmpresa}
                                    numero={inputEmpresa}
                                    pattern={'textOnly'}
                                />
                            </div>

                            <div className="campo">
                                <ClasicSelectTypeNew
                                    type="text"
                                    name="tipoEmpresa"
                                    id="tipoEmpresa"
                                    placeholder="Tipo de Empresa"
                                    className="desktopInput"
                                    refs={register(valTipoEmpresa)}
                                    options={tipoEmpresa}
                                    errorMessage={errors.tipoEmpresa && errors.tipoEmpresa.message}
                                />
                            </div>

                            <div className="campo">
                                <ClasicSelectTypeNew
                                    type="text"
                                    name="ocupacion"
                                    id="ocupacion"
                                    placeholder="Ocupación"
                                    className="desktopInput"
                                    refs={register(valOcupacion)}
                                    options={ocupacion}
                                    errorMessage={errors.ocupacion && errors.ocupacion.message}
                                />
                            </div>
                        </div>

                        <div className="secEmpleo">
                            <div className="campo">
                                <InputTypeAndroid
                                    type="text"
                                    id="telefono"
                                    name="telefono"
                                    autocomplete="tel"
                                    placeholder="Teléfono a 10 dígitos"
                                    className="desktopInput"
                                    errorMessage={errors.telefono && errors.telefono.message}
                                    refs={register(valTelefono)}
                                    setNumero={setInputTelefono}
                                    // value={inputTelefono}
                                    numero={inputTelefono}
                                    pattern={'number'}
                                    maxLength={10}
                                />
                            </div>

                            <div className="campo">
                                <InputTypeAndroid
                                    type="text"
                                    id="extension"
                                    name="extension"
                                    autocomplete="ext"
                                    placeholder="Extensión"
                                    className="desktopInput"
                                    errorMessage={errors.extension && errors.extension.message}
                                    refs={register(valExtension)}
                                    setNumero={setInputExtencion}
                                    value={inputExtencion}
                                    pattern={'number'}
                                    maxLength={4}
                                />
                            </div>

                            <div className="campo">
                                <div className="subCampo">
                                    <p>Tiempo de laborar en la empresa</p>
                                    <div className="doble">
                                        <div className="diaAnio">
                                            <InputTypeAndroid
                                                type="text"
                                                name="aniosEmpresa"
                                                id="aniosEmpresa"
                                                placeholder="Años"
                                                refs={register(valAniosEmpresa)}
                                                className="desktopInput labelRight"
                                                autocomplete='aniosEmpresa'
                                                setNumero={setInputAniosEmpresa}
                                                // value={inputAniosEmpresa}
                                                numero={inputAniosEmpresa}
                                                errorMessage={errors.aniosEmpresa && errors.aniosEmpresa.message}
                                                pattern={'number'}
                                                maxLength={2}
                                            />
                                        </div>
                                    </div>
                                    <div className="doble">
                                        <div className="diaAnio">
                                            <InputTypeAndroid
                                                type="text"
                                                name="mesesEmpresa"
                                                id="mesesEmpresa"
                                                placeholder="Meses"
                                                refs={register(valMesesEmpresa)}
                                                className="desktopInput labelRight"
                                                autocomplete='mesesEmpresa'
                                                setNumero={setInputMesesEmpresa}
                                                // value={inputMesesEmpresa}
                                                numero={inputMesesEmpresa}
                                                errorMessage={errors.mesesEmpresa && errors.mesesEmpresa.message}
                                                pattern={'number'}
                                                maxLength={2}
                                                max={11}
                                                min={1}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="secEmpleo">
                            <div className="campo">
                                <InputTypeAndroid
                                    type="text"
                                    id="calle"
                                    name="calle"
                                    placeholder="Calle"
                                    className="desktopInput"
                                    errorMessage={errors.calle && errors.calle.message}
                                    refs={register(valCalle)}
                                    pattern={'textOnly'}
                                    setNumero={setInputCalle}
                                    // value={inputCalle}
                                    numero={inputCalle}
                                    maxLength={30}
                                />
                            </div>

                            <div className="campo">
                                <div className="doble">
                                    <InputTypeAndroid
                                        type="text"
                                        id="numExt"
                                        name="numExt"
                                        placeholder="Núm ext."
                                        className="w25"
                                        errorMessage={errors.numExt && errors.numExt.message}
                                        refs={register(valNumExt)}
                                        setNumero={setInputNumExt}
                                        // value={inputNumExt}
                                        numero={inputNumExt}
                                        pattern={'textOnly'}
                                        maxLength={5}
                                    />
                                </div>
                                <div className="doble">
                                    <InputTypeAndroid
                                        type="text"
                                        id="numInt"
                                        name="numInt"
                                        placeholder="Núm int."
                                        className="w25"
                                        errorMessage={errors.numInt && errors.numInt.message}
                                        refs={register(valNumInt)}
                                        setNumero={setInputNumInt}
                                        value={inputNumInt}
                                        pattern={'textOnly'}
                                        maxLength={5}
                                    />
                                </div>
                            </div>

                            <div className="campo">
                                <div className="doble">
                                    <InputTypeAndroid
                                        type="text"
                                        id="cp"
                                        name="cp"
                                        placeholder="Código Postal"
                                        className="w25"
                                        errorMessage={errors.cp && errors.cp.message}
                                        refs={register(valCp)}
                                        pattern={'number'}
                                        maxLength={5}
                                        // value={inputCP}
                                        numero={inputCP}
                                        setNumero={setInputCP}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="secEmpleo">
                            <div className="campo">
                                {colonia && colonia.length >= 2
                                    ?
                                    <ClasicSelectTypeNew
                                        type="text"
                                        name="colonia"
                                        id="colonia"
                                        placeholder="Colonia"
                                        options={colonia}
                                        errorMessage={!colonia && (errors.colonia && errors.colonia.message)}
                                        refs={register(valColonia)}
                                        className="desktopInput"
                                    />
                                    : <InputTypeAndroid
                                        type="text"
                                        name="colonia"
                                        id="colonia"
                                        placeholder="Colonia"
                                        refs={register(valColonia)}
                                        value={colonia}
                                        readonly="readonly"
                                        errorMessage={!colonia && (errors.colonia && errors.colonia.message)}
                                        className="desktopInput"
                                    />
                                }
                            </div>

                            <div className="campo">
                                <InputTypeAndroid
                                    type="text"
                                    id="municipio"
                                    name="municipio"
                                    autocomplete="municipio"
                                    placeholder="Municipio"
                                    className="desktopInput"
                                    errorMessage={!municipio && (errors.municipio && errors.municipio.message)}
                                    refs={register(valMunicipio)}
                                    value={municipio}
                                    readonly="readonly"
                                />
                            </div>

                            <div className="campo">
                                <InputTypeAndroid
                                    type="text"
                                    id="estado"
                                    name="estado"
                                    autocomplete="estado"
                                    placeholder="Estado"
                                    className="desktopInput"
                                    errorMessage={!estado && (errors.estado && errors.estado.message)}
                                    refs={register(valEstado)}
                                    readonly="readonly"
                                    value={estado}
                                />
                            </div>
                        </div>

                        <div className="secEmpleo">
                            <div className="campo">
                                <InputTypeAndroid
                                    type="text"
                                    id="ciudad"
                                    name="ciudad"
                                    autocomplete="ciudad"
                                    placeholder="Ciudad"
                                    className="desktopInput"
                                    errorMessage={!ciudad && (errors.ciudad && errors.ciudad.message)}
                                    refs={register(valCiudad)}
                                    readonly="readonly"
                                    value={ciudad}
                                />
                            </div>

                            <div className="campo">

                                <InputTypeAndroid
                                    type="text"
                                    id="entreCalles"
                                    name="entreCalles"
                                    placeholder="Entre calles (opcional)"
                                    className="desktopInput"
                                    errorMessage={errors.entreCalles && errors.entreCalles.message}
                                    refs={register(valEntreCalles)}
                                    setNumero={setEntreCalles}
                                    value={entreCalles}
                                />
                            </div>

                            <div className="campo">
                            </div>
                        </div>

                        <div className="secEmpleo">
                            <div className="campo">
                                <InputTypeAndroid
                                    type="text"
                                    name="ingresosMensuales"
                                    id="ingresosMensuales"
                                    placeholder="Ingresos mensuales"
                                    refs={register(valIngresosMensuales)}
                                    className="desktopInput"
                                    autocomplete='ingresosMensuales'
                                    setNumero={setInputIngresosMensuales}
                                    // value={inputIngresosMensuales}
                                    numero={inputIngresosMensuales}
                                    errorMessage={errors.ingresosMensuales && errors.ingresosMensuales.message}
                                    pattern={'number'}
                                    maxLength={10}
                                />
                            </div>

                            <div className="campo">
                                <InputTypeAndroid
                                    type="text"
                                    name="otrosIngresos"
                                    id="otrosIngresos"
                                    placeholder="Otros ingresos"
                                    refs={register(valOtrosIngresos)}
                                    className="desktopInput"
                                    autocomplete="otrosIngresos"
                                    setNumero={setInputOtrosIngresos}
                                    value={inputOtrosIngresos}
                                    errorMessage={errors.otrosIngresos && errors.otrosIngresos.message}
                                    pattern={'number'}
                                    maxLength={10}
                                />
                            </div>

                            <div className="campo">
                                <InputTypeAndroid
                                    type="text"
                                    name="fuenteOtros"
                                    id="fuenteOtros"
                                    placeholder="Fuente de los otros ingresos"
                                    refs={register(valFuenteOtros)}
                                    className="desktopInput"
                                    autocomplete='fuenteOtros'
                                    setNumero={setInputFuenteOtros}
                                    value={inputFuenteOtros}
                                    errorMessage={errors.fuenteOtros && errors.fuenteOtros.message}
                                    pattern={'textOnly'}
                                    maxLength={20}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="botones">
                    <button className="btnRedCard">Continuar</button>
                    <button className="btnWhite" onClick={cancelar}>Cancelar</button>
                </div>
            </form>
            
            {showModalErr &&
                <ModalError
                    errorCode={errorCode}
                    section={sectionActive}
                    message={messageResponse}
                    handleClose={handleCloseErr}
                />
            }
        </>
    )
}

